import authConfig from './authConfig';

class AuthTokenManager {
  constructor() {
    this.access = null;
    this.refresh = null;
  }

  static getInstance() {
    if (!AuthTokenManager.instance) {
      AuthTokenManager.instance = new AuthTokenManager();
    }
    return AuthTokenManager.instance;
  }

  isAuthenticated() {
    return this.access != null || window.localStorage.getItem(authConfig.LOCAL_STORAGE_ACCESS_TOKEN) != null;
  }

  getAccessToken() {
    if (this.access != null)
      return this.access;
    const localToken = window.localStorage.getItem(authConfig.LOCAL_STORAGE_ACCESS_TOKEN);
    if (localToken != null) {
      this.access = localToken;
      return localToken;
    }
    return null;
  }

  getRefreshToken() {
    if (this.refresh != null)
      return this.refresh;
    const localToken = window.localStorage.getItem(authConfig.LOCAL_STORAGE_REFRESH_TOKEN);
    if (localToken != null) {
      this.refresh = localToken;
      return localToken;
    }
    return null;
  }

  setAccessToken(token) {
    return new Promise((resolve) => {
      this.access = token;
      window.localStorage.setItem(authConfig.LOCAL_STORAGE_ACCESS_TOKEN, token);
      resolve();
    });
  }

  setRefreshToken(token) {
    return new Promise((resolve) => {
      this.refresh = token;
      window.localStorage.setItem(authConfig.LOCAL_STORAGE_REFRESH_TOKEN, token);
      resolve();
    });
  }

  clear() {
    this.access = null;
    this.refresh = null;
    window.localStorage.removeItem(authConfig.LOCAL_STORAGE_ACCESS_TOKEN);
    window.localStorage.removeItem(authConfig.LOCAL_STORAGE_REFRESH_TOKEN);
  }
}

export const authTokenManager = AuthTokenManager.getInstance();